import { useState } from 'react';
import { adminApi } from '../api/adminApi';
import { useNavigate } from 'react-router-dom';
import ReviewsAdmin from '../components/Admin/ReviewsAdmin';
import NewsAdmin from '../components/Admin/NewsAdmin';
import EmployeesAdmin from '../components/Admin/EmployeesAdmin';
import ServicesAdmin from '../components/Admin/ServicesAdmin';
import GalleryAdmin from '../components/Admin/GalleryAdmin';

export default function AdminPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('gallery');

  const logout = async () => {
    try {
      await adminApi.logout();
      navigate('/admin/login');
    } catch (err) {
      console.error('Помилка при виході:', err);
    }
  };

  const tabs = [
    { id: 'gallery', label: 'Галерея', component: <GalleryAdmin /> },
    { id: 'services', label: 'Послуги', component: <ServicesAdmin /> },
    { id: 'employees', label: 'Співробітники', component: <EmployeesAdmin /> },
    { id: 'news', label: 'Новини', component: <NewsAdmin /> },
    { id: 'reviews', label: 'Відгуки', component: <ReviewsAdmin /> },
  ];

  return (
    <div className="admin-container">
      <header className="admin-header">
        <div className="header-content">
          <h1>Панель керування</h1>
          <button className="logout-btn" onClick={logout}>
            <span>Вийти</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
          </button>
        </div>
        
        <nav className="admin-tabs-wrapper">
          <div className="admin-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </nav>
      </header>

      <main className="admin-main">
        <div className="tab-content">
          {tabs.find(t => t.id === activeTab)?.component}
        </div>
      </main>

      <style>{`
        .admin-container {
          min-height: 100vh;
          background-color: #f0f9f7;
          font-family: 'Montserrat', sans-serif;
        }

        .admin-header {
          background-color: #ffffff;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          padding: 15px 15px 0 15px;
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto 15px;
        }

        .header-content h1 {
          font-size: clamp(1.1rem, 4vw, 1.5rem);
          color: #2d5a50;
          margin: 0;
        }

        .logout-btn {
          background-color: #ff7675;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: background 0.3s;
        }

        .logout-btn:hover { background-color: #d63031; }

        /* АДАПТИВНІ ВКЛАДКИ */
        .admin-tabs-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          overflow-x: auto; /* Дозволяє скролити вкладки на мобільних */
          scrollbar-width: none; /* Для Firefox */
          -ms-overflow-style: none; /* Для IE/Edge */
        }
        
        .admin-tabs-wrapper::-webkit-scrollbar { display: none; } /* Приховуємо скроллбар */

        .admin-tabs {
          display: flex;
          gap: 5px;
          min-width: max-content; /* Щоб кнопки не стискалися */
          padding-bottom: 2px;
        }

        .tab-btn {
          padding: 12px 16px;
          border: none;
          background: none;
          cursor: pointer;
          font-size: 0.95rem;
          color: #636e72;
          border-bottom: 3px solid transparent;
          transition: all 0.3s;
          white-space: nowrap;
        }

        .tab-btn.active {
          color: #1abc9c;
          border-bottom-color: #1abc9c;
          font-weight: 600;
        }

        .admin-main {
          max-width: 1200px;
          margin: 20px auto;
          padding: 0 15px;
        }

        .tab-content {
          background: white;
          padding: clamp(15px, 5vw, 30px);
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.03);
          min-height: 60vh;
        }

        /* МЕДІА-ЗАПИТИ */
        @media (max-width: 600px) {
          .logout-btn span {
            display: none; /* Ховаємо текст "Вийти" на дуже малих екранах */
          }
          .logout-btn {
            padding: 10px;
          }
          .admin-header {
            padding-top: 10px;
          }
          .admin-main {
            margin: 10px auto;
          }
        }

        /* Загальні стилі для таблиць всередині адмінки (якщо вони там є) */
        .tab-content table {
          width: 100%;
          border-collapse: collapse;
          display: block;
          overflow-x: auto; /* Таблиці теж стають скролабельними */
        }
      `}</style>
    </div>
  );
}